import { Milk } from "lucide-react";
import { Link } from "react-router-dom";

export function HatoEmptyState() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <div className="mb-6 text-app-ink-3">
        <Milk size={48} strokeWidth={1.5} />
      </div>
      <h2 className="mb-2 font-semibold text-2xl text-app-ink-1 tracking-tight">
        Tu hato está vacío
      </h2>
      <p className="mb-8 max-w-md text-app-ink-2 text-sm leading-relaxed">
        Empezá importando tu hato existente (desde VAMPP, Excel o tu propia planilla) o registrando
        el primer animal manualmente.
      </p>
      <div className="flex w-full max-w-xs flex-col gap-3">
        <Link
          to="/app/hato/import"
          className="inline-flex items-center justify-center rounded-2xl bg-app-ink-1 px-4 py-3 font-medium text-[14px] text-white transition-colors hover:bg-[#1e211d]"
        >
          Importar hato
        </Link>
        <Link
          to="/app/hato/nuevo"
          className="inline-flex items-center justify-center rounded-2xl border border-app-border bg-app-surface px-4 py-3 font-medium text-[14px] text-app-ink-1 transition-colors hover:bg-app-surface-2"
        >
          Registrar primer animal
        </Link>
        <Link
          to="/app/hato/import#columnas"
          className="mt-2 text-app-ink-3 text-sm hover:underline"
        >
          ¿Necesitás ayuda? Ver guía →
        </Link>
      </div>
    </div>
  );
}
